import loginBackground from "./loginbackground.png";
import menuBackground from "./menuBackground.png";
import formLoginBackground from "./formLoginBackground.jpg";
import Ellipse from "./Ellipse.png";

export const backgrounds = {
	loginBackground,
	menuBackground,
	formLoginBackground,
	Ellipse,
};
